import React from 'react';
import { Col, Row } from 'antd';
import { Dropdown } from '@app/components/common/Dropdown/Dropdown';
import { H6 } from '@app/components/common/typography/H6/H6';
import { ProfileOverlay } from '../ProfileOverlay/ProfileOverlay';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { useResponsive } from '@app/hooks/useResponsive';
import * as S from './ProfileDropdown.styles';
import CustomAvatar from '@app/components/common/Avatar/CustomAvatar';
import { DownOutlined } from '@ant-design/icons';

export const ProfileDropdown: React.FC = () => {
  const { isTablet } = useResponsive();

  const user = useAppSelector((state) => state.user.user);

  return user ? (
    <Dropdown overlay={<ProfileOverlay />} trigger={['click']}>
      <S.ProfileDropdownHeader as={Row} gutter={[10, 10]} align="middle">
        <Col>
          <CustomAvatar src={user.imgUrl} alt={user?.email.name} />
        </Col>
        {isTablet && (
          <Col>
            <H6>{`${user.email}`}</H6>
          </Col>
        )}
        <DownOutlined />
      </S.ProfileDropdownHeader>
    </Dropdown>
  ) : null;
};
